import React from "react";
import { LogOut, ShieldCheck } from "lucide-react";

import { getLabel, logout } from "../lib/auth";

const CPS_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_workshops-wind-data/artifacts/lvwu5z7c_CPS_Trans_400.png";

export default function Header() {
  const label = getLabel();

  async function onLogout() {
    await logout();
    // Force a hard refresh so the AuthGate re-mounts without any stale state.
    window.location.reload();
  }

  return (
    <header
      className="bg-white border-b border-gray-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img
            src={CPS_LOGO_URL}
            alt="Community Power Solutions"
            className="h-20 w-auto object-contain flex-shrink-0"
            data-testid="site-logo"
          />
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
              Community Engagement Insights
            </h1>
            <p className="text-sm text-gray-600 mt-0.5">
              South Downs Region · Onshore Wind Workshops · Evidence Dashboard
            </p>
          </div>
        </div>
        <div className="hidden md:flex flex-col items-end gap-1 text-right text-xs text-gray-500 font-mono">
          {label ? (
            <span
              className="inline-flex items-center gap-1.5 bg-[#F8FAF9] border border-[#2F4F4F] text-[#2F4F4F] px-2 py-1"
              data-testid="session-label"
            >
              <ShieldCheck className="h-3 w-3" />
              {label}
            </span>
          ) : null}
          <button
            onClick={onLogout}
            className="inline-flex items-center gap-1 text-gray-500 hover:text-gray-900 transition-colors"
            data-testid="header-logout"
          >
            <LogOut className="h-3 w-3" /> Sign out
          </button>
        </div>
      </div>

      {/* Always-visible methodology strapline */}
      <div
        className="bg-white border-t border-gray-100"
        data-testid="methodology-strapline"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 text-[12px] text-gray-600 leading-snug">
          This dashboard presents both{" "}
          <span className="font-semibold text-gray-800">conservative (explicit)</span>{" "}
          and{" "}
          <span className="font-semibold text-[#2F4F4F]">interpretive (behavioural)</span>{" "}
          readings of the dataset to reflect how participants express
          preferences in deliberative settings.
        </div>
      </div>
    </header>
  );
}
